import { C } from "../theme/tokens";

/**
 * La rotellina dell'elaborazione, con la barra che scorre sotto. Le
 * animazioni (obscura-spin, obscura-progress) le definisce la pagina di
 * anonimizzazione.
 */
export default function Rotellina() {
  return (
    <>
      <svg width="64" height="64" viewBox="0 0 80 80" style={{ animation: "obscura-spin 2s linear infinite" }} aria-hidden="true">
        <circle cx="40" cy="40" r="30" fill="none" stroke={C.smartBlue30} strokeWidth="3"/>
        <path d="M40 10 A30 30 0 0 1 70 40" fill="none" stroke={C.smartBlue} strokeWidth="3" strokeLinecap="round"/>
        <path d="M40 10 C40 25,25 40,40 40 C55 40,40 55,40 70" fill="none" stroke={C.smartBlue50} strokeWidth="2"/>
      </svg>
      <div style={{ width: 220, maxWidth: "100%", height: 4, background: C.smartBlue30, borderRadius: 2, overflow: "hidden" }}>
        <div style={{ height: "100%", background: C.smartBlue, borderRadius: 2, animation: "obscura-progress 2.5s ease-in-out infinite" }}/>
      </div>
    </>
  );
}
